module.exports = {
    sundayFirst: false,
    startingDate: new Date(),
    dateLabelFormat: "dd.MM.YYYY",
    days: [
      "Mandag",
      "Tirsdag",
      "Onsdag",
      "Torsdag",
      "Fredag",
      "Lørdag",
      "Søndag"
    ],
    daysShort: ["Man", "Tirs", "Ons", "Tors", "Fre", "Lør", "Søn"],
    monthNames: [
      "Januar",
      "Februar",
      "Marts",
      "April",
      "Maj",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "December"
    ],
    colors: {
    //   selected: "#14143c",
    //   inRange: "#72728a",
    //   selectedText: "#fff",
    //   text: "#565a5c",
    //   inRangeBorder: "#72728a",
    //   disabled: "#fff",
    //   hoveredInRange: "#72728a"
    },
    texts: {
      apply: "Vælg og luk",
      cancel: " ",
      keyboardShortcuts: "Tastatur genveje"
    },
    keyboardShortcuts: [
      {
        symbol: "↵",
        label: "Vælg datoen i der er i fokus",
        symbolDescription: "Retur tast"
      },
      {
        symbol: "←/→",
        label: "Gå en dag tilbage (venstre), Gå en dag fremad (højre).",
        symbolDescription: "Venstre og højre piletaster"
      },
      {
        symbol: "↑/↓",
        label: "Gå en uge tilbage (op) og en uge fremad (ned).",
        symbolDescription: "Op eller ned piletaster"
      },
      {
        symbol: "PgUp/PgDn",
        label: "Skift måned.",
        symbolDescription: "PageUp og PageDown taster"
      },
      {
        symbol: "Home/End",
        label: "Gå til den første eller sidste dag i ugen.",
        symbolDescription: "Home eller End taster"
      },
      {
        symbol: "Esc",
        label: "Luk dette panel",
        symbolDescription: "Escape tast"
      },
      {
        symbol: "?",
        label: "Åbn dette panel",
        symbolDescription: "Spørgsmålstegn"
      }
    ]
  };